<template>
  <div class="card">
    <el-row :gutter="40">
      <el-col :span="10">
        <div class="card-body">
          <div class="d-flex with-button">
            <div class="p-2">
              <h1 class="title">커리큘럼</h1>
            </div>
            <div class="p-2 small bottom">
              총 <strong><span class="number mint">{{bookTableData.length}}</span></strong> 건
            </div>
            <div class="ml-auto p-2">
              <button type="button" class="btn mint" @click="handleCommand('book')">+ 커리큘럼 추가</button>
            </div>
          </div>

          <div class="d-flex">
            <div class="p-2 w-100">
              <div class="input-group search">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="search.search_text" @keyup.enter="retrieve" placeholder="커리큘럼명">
                <div class="input-group-apend">
                  <button type="button" class="btn btn-default" @click="retrieve">
                     검색
                  </button>
                </div>
              </div>
            </div>
            <div class="p-2 search-detail" v-if="searchDetailVisible">
              <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
            </div>
          </div>

        </div>

        <stone-data-table
          :loading="searchLoading"
          table-ref="bookTable"
          :current-row="currentRow"
          :columns="bookTableColumns"
          :data="bookTableData"
          :table-props="bookTableProps"
          :action-col="bookActionCol"
          @row-click="bookRowClickHandler">
        </stone-data-table>
      </el-col>

      <el-col :span="14">
        <div class="card-body">
          <div class="d-flex with-button">
            <div class="p-2">
              <h1 class="title">회차 구성</h1>
            </div>
            <div class="p-2 small bottom">
              총 <strong><span class="number mint">{{curriculumTableData.length}}</span></strong> 건
            </div>
            <div class="ml-auto p-2">
              <button type="button" class="btn mint" @click="handleCommand('curriculum')">+ 회차 추가</button>
            </div>
          </div>
          <div class="d-flex">
            <div class="p-2 w-100">
              <div class="input-group search">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="curriculumFilters[0].value" placeholder="회차명">
              </div>
            </div>
          </div>
        </div>

        <stone-data-table
          :loading="searchLoadingCurriculum"
          :columns="curriculumTableColumns"
          :data="curriculumTableData"
          :filters="curriculumFilters"
          :table-props="curriculumTableProps"
          :action-col="curActionCol"
          :page-size="emptyPageSize"
          :pagination-props="emptyPaginationProps">
        </stone-data-table>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="dialogVisible.book" append-to-body class="dialog-small" title="커리큘럼">
      <el-form :model="bookfrm" :rules="rules" ref="bookform" label-width="120px" class="demo-form">
        <el-form-item label="커리큘럼명" prop="book_name">
          <el-input v-model.trim="bookfrm.book_name" :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="카테고리코드" prop="cate_code">
          <el-cascader
            :options="options"
            v-model="selectedOptions"
            separator=">"
            filterable
            change-on-select
            @change="handleChange"
            style="width: 100%">
          </el-cascader>
        </el-form-item>
        <el-form-item label="커리큘럼코드" prop="book_code">
          <el-input v-model.trim="bookfrm.book_code" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="비고" prop="rmrk">
          <el-input type="textarea" :rows="5" v-model="bookfrm.rmrk" :maxlength="250"></el-input>
        </el-form-item>

        <div class="text-right">
          <el-button @click="dialogVisible['book'] = false">닫기</el-button>
          <template v-if="bookfrm.book_seq !== ''">
            <el-button type="danger" @click="deleteRow('/book')">삭제</el-button>
            <el-button type="primary" @click="updateRow('bookform', '/book')">수정</el-button>
          </template>
          <template v-else>
            <el-button v-if="bookfrm.book_seq === ''" type="primary" @click="updateRow('bookform', '/book')">저장</el-button>
          </template>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog class="dialog-small" :visible.sync="dialogVisible.curriculum" append-to-body title="회차">
      <el-form :model="curriculumfrm" :rules="rules" ref="curriculumform" class="demo-form">
        <el-form-item label="커리큘럼" prop="book_seq">
          <el-select v-model="curriculumfrm.book_seq" placeholder="커리큘럼을 선택하세요">
            <el-option v-for="book in books" :label="book.book_name" :value="book.book_seq" :key="book.book_seq"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="회차" prop="times">
          <el-input-number v-model="curriculumfrm.times" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="회차명" prop="curriculum_name">
          <el-input v-model.trim="curriculumfrm.curriculum_name" :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="비고" prop="rmrk">
          <el-input type="textarea" :rows="5" v-model="curriculumfrm.rmrk" :maxlength="250"></el-input>
        </el-form-item>

        <div class="text-right">
          <el-button @click="dialogVisible['curriculum'] = false">닫기</el-button>
          <template v-if="curriculumfrm.curriculum_seq !== ''">
            <el-button type="danger" @click="deleteRow('/curriculum')">삭제</el-button>
            <el-button type="primary" @click="updateRow('curriculumform', '/curriculum')">수정</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="updateRow('curriculumform', '/curriculum')">저장</el-button>
          </template>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import common from '@/modules/common'

export default {
  name: 'M010101',
  mixins: [common.mixins],
  data () {
    let checkCodeID = (rule, value, callback) => {
      let regType = /^[A-Za-z0-9_]*$/
      // check the regular expression
      if (!regType.test(value)) {
        callback(new Error('코드ID는 영문과 숫자, 특수문자 중 "_" 만 사용 가능합니다.'))
      } else {
        callback()
      }
    }
    return {
      searchLoadingCurriculum: false,
      bookfrm: {
        book_seq: '',
        book_code: '',
        book_name: '',
        cate_code: '',
        rmrk: ''
      },
      curriculumfrm: {
        curriculum_seq: '',
        book_seq: '',
        curriculum_name: '',
        times: 1,
        rmrk: ''
      },
      books: [],
      rules: {
        book_code: [
          { min: 1, max: 20, message: '최소 1자 이상 20자 이내로 입력하십시오.' },
          { validator: checkCodeID, trigger: 'blur' }
        ],
        book_name: [
          { required: true, message: '커리큘럼명을 입력하십시오.', trigger: 'blur' },
          { min: 1, max: 50, message: '최소 1자 이상 50자 이내로 입력하십시오.' }
        ],
        rmrk: [
          { min: 1, max: 250, message: '최소 1자 이상 250자 이내로 입력하십시오.' }
        ],
        curriculum_name: [
          { required: true, message: '회차명을 입력하십시오.', trigger: 'blur' },
          { min: 1, max: 50, message: '최소 1자 이상 50자 이내로 입력하십시오.' }
        ],
        times: [
          { required: true, message: '회차를 입력하십시오.', trigger: 'blur' }
        ],
        cate_code: [
          { min: 1, max: 20, message: '최소 1자 이상 20자 이내로 입력하십시오.' }
        ],
        book_seq: [
          { required: true, message: '커리큘럼을 선택하십시오.', trigger: 'change' }
        ]
      },
      currentPage: 0,
      currentRow: null,
      bookTableData: [],
      bookTableColumns: [
        {label: 'No', type: 'index', class: 'no-point'},
        // {label: '번호', prop: 'book_seq', align: 'left'},
        {label: '커리큘럼명', prop: 'book_name', align: 'left', width: 150, class: 'no-point'},
        {label: '구분', prop: 'cate_name', align: 'left', class: 'no-point'}
      ],
      bookTableProps: {height: this.getScreenHeight(), highlightCurrentRow: true},
      bookActionCol: {
        label: ' ',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.goEdit('/book/', row.book_seq)
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: '상세'
        }]
      },
      curriculumTableData: [],
      curriculumFilters: [
        {prop: ['curriculum_name'], value: ''}
      ],
      curriculumTableColumns: [
        {label: '회차', prop: 'times', align: 'center', class: 'no-point'},
        {label: '회차명', prop: 'curriculum_name', align: 'left', width: 250, class: 'no-point'}
      ],
      curriculumTableProps: {height: this.getScreenHeight()},
      curActionCol: {
        label: ' ',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.goEdit('/curriculum/', row.curriculum_seq)
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: '상세'
        }]
      },
      dialogVisible: {book: false, curriculum: false},
      search: {seq: '', search_text: ''},
      options: [],
      selectedOptions: []
    }
  },
  beforeCreate () {
  },
  created () {
    this.retrieve()
    common.axios.get('/category/tree')
      .then(response => {
        this.options = response.data
      })
  },
  methods: {
    // 리스트
    retrieve () {
      // const curriculumBookSeq = this.curriculumfrm.book_seq
      this.currentRow = null
      this.curriculumTableData = []
      this.loadStoneDataTable('/book/list', this.search)
        .then(response => {
          this.bookTableData = response.data
          this.books = response.data

          // if (curriculumBookSeq) {
          //   this.retrieveCurriculum(this.curriculumfrm.book_seq)
          // }
        })
    },
    // 교재 테이블 row click
    bookRowClickHandler (row, event, column) {
      this.currentRow = row
      this.retrieveCurriculum(row.book_seq)
    },
    retrieveCurriculum (bookSeq) {
      this.searchLoadingCurriculum = true
      common.axios.post('/curriculum/list', {book_seq: bookSeq})
        .then(response => {
          this.searchLoadingCurriculum = false
          this.curriculumTableData = response.data
        })
        .catch(() => {
          this.searchLoadingCurriculum = false
        })
    },
    // 상세 보기 클릭 이벤트
    goEdit (url, seq) {
      let str = this.getfrmNameFunc(url)
      this.loadData(url + seq, str)
      this.dialogVisible[str] = true
    },
    // 교재 상세 내 카테고리 cascader change
    handleChange (value) {
      this.bookfrm.cate_code = value[value.length - 1]
    },
    // 추가 command click
    handleCommand (command) {
      if (this.$refs[command + 'form']) {
        this.$refs[command + 'form'].resetFields()
      }
      if (command === 'curriculum') {
        // 교재가 선택되어 있을 경우에는 해당 교재를 자동으로 설정해준다.
        this.curriculumfrm.book_seq = this.currentRow ? this.currentRow.book_seq : ''
        // 회차는 현재 커리큘럼에 가장 마지막 회차에 1를 더해준다.
        this.curriculumfrm.times = this.curriculumTableData && this.curriculumTableData.length > 0 ? this.curriculumTableData.slice(-1)[0].times + 1 : 1
      }
      this.getFrmObjFunc(command)[command + '_seq'] = ''
      this.selectedOptions = []
      this.dialogVisible[command] = true
    },
    // 삭제
    deleteRow (url) {
      let urlName = this.getfrmNameFunc(url)
      this.$confirm('삭제하시겠습니까?', '', {
      }).then(() => {
        const frmObj = this.getFrmObjFunc(urlName)
        common.axios.delete(url, {data: frmObj})
          .then(response => {
            this.$message('삭제되었습니다.')
            if (url === '/book') {
              this.retrieve()
            } else {
              this.retrieveCurriculum(frmObj.book_seq)
            }
            this.dialogVisible[urlName] = false
          })
          .catch(() => {
            this.$message.error('삭제에 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    },
    // 수정 & 추가
    updateRow (formName, urlAddr) {
      const urlName = this.getfrmNameFunc(urlAddr)
      const frmObj = this.getFrmObjFunc(urlName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const isInsert = frmObj[urlName + '_seq'] === ''
          const config = {
            url: isInsert ? urlAddr + '/storage' : urlAddr,
            method: isInsert ? 'post' : 'put',
            data: frmObj
          }
          common.axios.request(config)
            .then(response => {
              if (response.data.result === 409) {
                this.$message.error('회차가 중복되었습니다.')
                // 다른 사용자가 회차 정보를 입력하는 경우가 있어서 커리큘럼을 다시 한 번 조회해준다.
                this.retrieveCurriculum(frmObj.book_seq)
              } else {
                if (isInsert) {
                  this.$message('등록하였습니다.')
                } else {
                  this.$message('수정하였습니다.')
                }
                this.dialogVisible[urlName] = false
                if (formName === 'bookform') {
                  this.retrieve()
                } else {
                  this.retrieveCurriculum(frmObj.book_seq)
                }
              }
            })
            .catch(error => {
              if (error.response.data.errors) {
                error.response.data.errors.map(msg => {
                  this.$message.error(msg)
                })
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    // 상세 보기 load
    loadData (url, str) {
      common.axios.get(url)
        .then(response => {
          const result = response.data
          Object.keys(this.getFrmObjFunc(str)).forEach(key => {
            this.getFrmObjFunc(str)[key] = result[key]
          })
          if (result.select_option) {
            this.selectedOptions = result.select_option.split(' > ')
          } else {
            this.selectedOptions = []
          }
        })
    },
    getFrmObjFunc (str) {
      let frmObj = {}
      if (str === 'book') {
        frmObj = this.bookfrm
      } else if (str === 'curriculum') {
        frmObj = this.curriculumfrm
      }
      return frmObj
    },
    getfrmNameFunc (url) {
      return url.split('/')[1]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/M010101.vue